import { FC } from 'react';
import {
  FilterSection,
  ColumnDateFilter,
  ColumnMultiSelectFilter,
} from 'components/data-table';
import type { EvaluationCaseFacets } from './types';
import styles from './evaluation-cases-filters.module.scss';

interface EvaluationCasesFiltersProps {
  facets: EvaluationCaseFacets | undefined;
}

/**
 * Converts a string array to options format for ColumnMultiSelectFilter.
 * @param {string[] | undefined} items - Array of string values (e.g., evaluation type options)
 * @return {Array<Object>} Options array with value and label
 */
const toStringOptions = (items: string[] | undefined) =>
  (items ?? []).map((item) => ({ value: item, label: item }));

/**
 * Converts an id/value pair array to options format for ColumnMultiSelectFilter.
 * @param {Array<Object> | undefined} items - Array of { id, value } objects (e.g., created by options)
 * @return {Array<Object>} Options array with value and label
 */
const toIdOptions = (items: { id: string; value: string }[] | undefined) =>
  (items ?? []).map((item) => ({ value: item.id, label: item.value }));

const EvaluationCasesFilters: FC<EvaluationCasesFiltersProps> = ({
  facets,
}) => {
  return (
    <div className={styles.filtersWrapper}>
      <FilterSection title="Date Filters">
        <ColumnDateFilter columnId="createdAt" label="Created At" />
        <ColumnDateFilter columnId="updatedAt" label="Updated At" />
      </FilterSection>

      <FilterSection title="Case Details">
        <ColumnMultiSelectFilter
          columnId="evaluationType"
          label="Evaluation Type"
          options={toStringOptions(facets?.evaluationTypeOptions)}
        />
        <ColumnMultiSelectFilter
          columnId="createdBy"
          label="Created By"
          options={toIdOptions(facets?.createdByOptions)}
        />
      </FilterSection>
    </div>
  );
};

export { EvaluationCasesFilters };
